export const defaultStyle = {
    profileSectionWrapper: 'profileSectionWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto',
    profileSection: 'total-mange-team-area flex flex-wrap text-center py-[30px] lg:py-[50px] px-[35px] md:px-15 mx-[-25px] md:mx-[-50px] justify-center md:justify-start',
    profileWrapper: 'basis-[50%] md:basis-auto md:w-1/3 lg:w-1/4 px-25 md:px-50 mb-80',
    profileImg: 'absolute rounded-[150px] top-0 z-[1] h-full',
    profileName: 'text-[12px] md:text-[18px] font-Bold tracking-[0.45px] leading-[1.5] px-10',
    profileDesignation: 'text-[12px] md:text-[18px] tracking-[0.45px] leading-[1.5] px-10',
    profileShapePic: 'profile-shape-picture-area block w-full relative mb-20 lg:mb-[45px] text-center'
}